'use es6';

import keyMirror from 'react-utils/keyMirror';
export default Object.freeze(keyMirror({
  EMPTY_VALUE: null,
  INVALID_CHARACTERS: null,
  INVALID_EXTENSION: null,
  MAX_LENGTH: null
}));